import { STATUS } from '../const/app';

// Should initSearchEpic (re)fetch events for this broadcast?
// events_status is now a constant 'events_finished', so "status changed" no longer marks a new search -
// without the new-id check, a second search keeps showing the first search's events. Pure, so it's tested on its own.
export const shouldFetchEvents = (
  travelSearch: { id: number; events_status: string },
  currentSearch: { id: number; eventsStatus?: string }
): boolean => {
  const isNewSearch = currentSearch.id !== travelSearch.id;

  return travelSearch.events_status === STATUS.EVENTS_FINISHED
    && (isNewSearch || currentSearch.eventsStatus !== travelSearch.events_status);
};
